import { takeLatest, put, call } from "redux-saga/effects";
import request from "../../../components/Utils/httpHelper";
import { CORE_API } from "../../../config";
import { HTTP_HEADERS } from "../../../constants";
import { Preloading } from "../../../components/UI/Preloader/action";
import { TASK_CONFIG } from "../constants";
import { DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA } from "../actionTypes";
import { extractApiErrorMessage } from "../helper";
import {
  deleteExecutiveSummaryFinancialDataSuccess,
  deleteExecutiveSummaryFinancialDataFailure,
} from "../action";

export function* deleteExecutiveSummaryFinancialDataSaga(action) {
  const { caseId } = action.payload || {};
  const requestURL = `${CORE_API}${TASK_CONFIG.DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA.deleteEndpoint}`;

  try {
    const response = yield call(request, requestURL, {
      method: "DELETE",
      headers: HTTP_HEADERS,
      data: { caseId },
    });
    yield put(
      deleteExecutiveSummaryFinancialDataSuccess({
        response: response.data,
      })
    );
  } catch (err) {
    yield put(
      deleteExecutiveSummaryFinancialDataFailure({
        message: extractApiErrorMessage(
          err,
          "Failed to delete executive summary financial data"
        ),
        status: "FAILURE",
      })
    );
  } finally {
    yield put(Preloading(false));
  }
}

export function* watchDeleteExecutiveSummaryFinancialData() {
  yield takeLatest(
    DELETE_EXECUTIVE_SUMMARY_FINANCIAL_DATA,
    deleteExecutiveSummaryFinancialDataSaga
  );
}
